import React from 'react';
interface MonogramProps {
  className?: string;
  rule?: boolean;
}
export function Monogram({
  className = '',
  rule = false
}: MonogramProps) {
  return <div className={`inline-flex flex-col items-center ${className}`} data-id="element-50" data-mp="3m6euxesy0n3z">
      <div className="font-serif tracking-[0.3em] text-brass leading-none" data-id="element-51" data-mp="3h84x0wfu38eo">
        V <span className="mx-0.5 font-sans text-[0.7em] align-middle" data-id="element-52" data-mp="3cb4s4ouq0bp5">·</span>{' '}
        R
      </div>
      {rule && <div className="mt-2 h-px w-8 bg-brass/80" aria-hidden="true" data-id="element-53" data-mp="37ca8xlsucl4i" />}
    </div>;
}